import React, { Component } from 'react'
import { TableBody } from 'react-md'

import ListRow from './ListRow'

class ListBody extends Component {
  render () {
    const { fields } = this.props

    return (
      <TableBody>
        { fields.map((member, index) => (
          <ListRow {...this.props} key={member} member={member} index={index} />
        )) }
      </TableBody>
    )
  }
}

export default ListBody



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/CommissionsView/CommissionList/ListBody.js